import { STR_FAILURE, STR_SUCCESS } from "core/constants/strings"
import { useAuth } from "core/context/auth"
import useToast from "core/hooks/useToast"
import { genError } from "core/utils/string"
import { SheetsAPIDataSourceImpl } from "data/API/Admin/SheetsAPIDataSourceImpl"
import { CreateClassAPIDataSourceImpl } from "data/API/Admin/CreateClassAPIDataSourceImpl"
import { SheetsRepositoryImpl } from "data/repository/Admin/SheetsRepositoryImpl"
import { CreateClassRepositoryImpl } from "data/repository/Admin/CreateClassRepositoryImpl"
import { GetBatchStudentDetails } from "domain/useCase/Admin/Sheets/GetBatchStudentDetails"
import { GetAllBatches } from "domain/useCase/Admin/CreateClass/GetAllBatches"
import React from "react"
import { GetBatchYearData } from "domain/useCase/Admin/Sheets/GetBatchYearData"
import { GetMentorListData } from "domain/useCase/Admin/Sheets/GetMentorListData"
import { GetBatchCertificates } from "domain/useCase/Admin/Sheets/GetBatchCertificates"
import { GetMentorInvoices } from "domain/useCase/Admin/Sheets/GetMentorInvoices"
import { GetInstructorInvoices } from "domain/useCase/Admin/Sheets/GetInstructorInvoices"
import { GetMentorInstructorInvoices } from "domain/useCase/Admin/Sheets/GetMentorInstructorInvoices"
import { GetActiveBatches } from "domain/useCase/Admin/Sheets/GetActiveBatchListData"
import { GetICPStudentsOfBatch } from "domain/useCase/Admin/Sheets/GetICPActiveStudentListData"
import { GetDoubtRaisedStats } from "domain/useCase/Admin/Sheets/GetDoubtRaisedStats"
import { UpdateBatchData } from "domain/useCase/Admin/Sheets/UpdateBatchData"
import { AllotMentors } from "domain/useCase/Admin/Sheets/AllotMentors"
import { BatchStudentsAPIDataSourceImpl } from "data/API/Admin/BatchStudentsAPIDataSourceImpl"
import { ActiveBatchRepositoryImpl } from "data/repository/Admin/ActiveBatchRepositoryImpl"
import { BatchAPIDataSources } from "data/API/Admin/BatchAPIDataSources"
import { ICPStudentRepositoryImpl } from "data/repository/Admin/ICPStudentRepositoryImpl"
import { ICPStudentAPIDataSource } from "data/API/Admin/ICPStudentAPIDataSource"
import { GetICPStudentsOfNonactiveBatch } from "domain/useCase/Admin/Sheets/GetICPActiveStudentListNonActiveBatchListData"
import { GetICPStudentsOfAllBatch } from "domain/useCase/Admin/Sheets/GetICPActiveStudentListAllBatchListData"
import { GetTempMentorAnalysis } from "domain/useCase/Admin/Sheets/GetTempMentorAnalysis"

export default function SheetsViewModel() {
  const [allBatches, setAllBatches] = React.useState([])
  const [batch, setBatch] = React.useState("")
  const [fromDate, setFromDate] = React.useState("")
  const [toDate, setToDate] = React.useState("")
  const [activityStatus, setActivityStatus] = React.useState("")
  const [fromDate2, setFromDate2] = React.useState("")
  const [toDate2, setToDate2] = React.useState("")
  const [fromDate3, setFromDate3] = React.useState("")
  const [toDate3, setToDate3] = React.useState("")
  const [isLoading, setIsLoading] = React.useState(false)
  const [isLoading2, setIsLoading2] = React.useState(false)
  const [isLoading3, setIsLoading3] = React.useState(false)
  const [isLoading8, setIsLoading8] = React.useState(false)
  const [isLoading4, setIsLoading4] = React.useState(false)
  const [isLoading5, setIsLoading5] = React.useState(false)
  const [isLoading6, setIsLoading6] = React.useState(false)
  const [isLoading7, setIsLoading7] = React.useState(false)
  const [month, setMonth] = React.useState<any>("")
  const [selectedMonth, setSelectedMonth] = React.useState<any>("")
  const [selectedRole, setSelectedRole] = React.useState("")
  const [monthList, setMonthList] = React.useState<any>([])
  const [year, setYear] = React.useState<any>({})
  const [selectedYear, setSelectedYear] = React.useState<any>({})

  const [allBatches2, setAllBatches2] = React.useState([])
  const [batch2, setBatch2] = React.useState("")
  const [dataSetButton, setDataSetButton] = React.useState(false)
  const [blurSelect, setBlurSelect] = React.useState(false)
  const [dataButtonLoading, setDataButtonLoading] = React.useState(false)
  const [downloadData, setDownloadData] = React.useState(false)
  const [batch3, setBatch3] = React.useState("")
  const [batch4, setBatch4] = React.useState("")
  const [batch5, setBatch5] = React.useState("")
  const [selectedBatch, setSelectedBatch] = React.useState("")
  const [allotMentorsLoading, setAllotMentorsLoading] = React.useState(false)
  const { auth } = useAuth()
  const { toast, changeToastDetails, changeToastVisibility } = useToast()
  const [course, setCourse] = React.useState("")

  const allCourses = ["Evolve", "Transformer", "Data_Scientist", "Data_Analyst", "Data-(Scientist+Analyst)"]

  const getAllBatchesUseCase = new GetAllBatches(new CreateClassRepositoryImpl(new CreateClassAPIDataSourceImpl()))

  const getBatchStudentDetailsUseCase = new GetBatchStudentDetails(
    new SheetsRepositoryImpl(new SheetsAPIDataSourceImpl())
  )

  const getBatchYearDataUseCase = new GetBatchYearData(new SheetsRepositoryImpl(new SheetsAPIDataSourceImpl()))

  const getMentorListDataUseCase = new GetMentorListData(new SheetsRepositoryImpl(new SheetsAPIDataSourceImpl()))

  const getBatchCertificatesUseCase = new GetBatchCertificates(new SheetsRepositoryImpl(new SheetsAPIDataSourceImpl()))

  const getMentorInvoicesUseCase = new GetMentorInvoices(new SheetsRepositoryImpl(new SheetsAPIDataSourceImpl()))

  const getInstructorInvoicesUseCase = new GetInstructorInvoices(
    new SheetsRepositoryImpl(new SheetsAPIDataSourceImpl())
  )

  const getMentorInstructorInvoicesUseCase = new GetMentorInstructorInvoices(
    new SheetsRepositoryImpl(new SheetsAPIDataSourceImpl())
  )

  const getICPStudentsOfBatchUseCase = new GetICPStudentsOfBatch(
    new ICPStudentRepositoryImpl(new ICPStudentAPIDataSource())
  )

  const getICPStudentsOfNonactiveBatchUseCase = new GetICPStudentsOfNonactiveBatch(
    new ICPStudentRepositoryImpl(new ICPStudentAPIDataSource())
  )

  const getICPStudentsOfAllBatchUseCase = new GetICPStudentsOfAllBatch(
    new ICPStudentRepositoryImpl(new ICPStudentAPIDataSource())
  )

  const getActiveBatchesUseCase = new GetActiveBatches(new ActiveBatchRepositoryImpl(new BatchAPIDataSources()))

  const getDoubtRaisedStatsUseCase = new GetDoubtRaisedStats(new SheetsRepositoryImpl(new SheetsAPIDataSourceImpl()))

  const updateBatchDataUseCase = new UpdateBatchData(new SheetsRepositoryImpl(new SheetsAPIDataSourceImpl()))

  const allotMentorsUseCase = new AllotMentors(new SheetsRepositoryImpl(new SheetsAPIDataSourceImpl()))

  const getTempMentorAnalysisUseCase = new GetTempMentorAnalysis(
    new SheetsRepositoryImpl(new SheetsAPIDataSourceImpl())
  )

  const fetchAllBatches = async () => {
    const response = await getAllBatchesUseCase.invoke(auth)

    if (!response?.success) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, genError(response, "Error fetching batches"))
      return
    }

    setAllBatches(response?.data)
  }

  const fetchAllBatches2 = async () => {
    const response = await getAllBatchesUseCase.invoke(auth)

    if (!response?.success) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, genError(response, "Error fetching batches"))
      return
    }

    setAllBatches2(response?.data)
  }

  const handleFormSubmit = async (e: any) => {
    e.preventDefault()

    if (!batch || !fromDate || !toDate) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Please fill all the fields")
      return
    }

    const fromTimestamp = new Date(fromDate).getTime()
    const toTimestamp = new Date(toDate).getTime()
    const currTimestamp = Date.now()
    if (fromTimestamp > toTimestamp) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "From date cannot be greater than to date")
      return
    }
    if (fromTimestamp > currTimestamp || toTimestamp > currTimestamp) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Enter a valid date")
      return
    }

    try {
      setIsLoading(true)
      const response = await getBatchStudentDetailsUseCase.invoke(
        {
          batch,
          fromDate,
          toDate,
          activityStatus,
        },
        auth
      )

      ///
      console.log(response.data)
      downloadStudentsData(response.data)
    } catch (error) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Error downloading file")
    }
    setIsLoading(false)
  }

  function downloadStudentsData(data: any) {
    const headers = [
      "Name",
      "Batch",
      "Email",
      "Phone",
      "Experience",
      "Leetcode ID",
      "PS on LC Date Range",
      "PS on Platform Date Range",
      "Total PS Date Range",
      "Total LC Count",
      "Total Platform Count",
      "Total Problems Solved",
      "Classes Attended Date range",
      "Classes held Date range",
      "Total Classes Attended",
      "Total Classes held",
      "Activity Status in Date Range",
      "Overall Activity Status",
    ]
    const csvContent = [
      headers.join(","),
      ...data.map((row: any) =>
        headers
          .map((header) => {
            return row[header] !== undefined ? row[header] : ""
          })
          .join(",")
      ),
    ].join("\n")
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const link = document.createElement("a")
    const url = URL.createObjectURL(blob)
    link.setAttribute("href", url)
    link.setAttribute("download", "student_batch_detail.csv")
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }
  const handleFormSubmitDoubtSupport = async (e: any) => {
    e.preventDefault()
    if (!fromDate2 || !toDate2) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Please fill all the fields")
      return
    }

    const fromTimestamp = new Date(fromDate2).getTime()
    const toTimestamp = new Date(toDate2).getTime()

    if (fromTimestamp > toTimestamp) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "From date cannot be greater than to date")
      return
    }

    try {
      setIsLoading3(true)
      const response = await getDoubtRaisedStatsUseCase.invoke({
        fromDate2,
        toDate2,
      })

      const csvContent = `data:text/csv;charset=utf-8,${response}`

      const encodedUri = encodeURI(csvContent)
      const link = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("download", "DOUBTQUERIES.csv")
      document.body.appendChild(link)

      link.click()
    } catch (error) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Error downloading file")
    }
    setIsLoading3(false)
  }

  const handleFormSubmitMentorList = async (e: any) => {
    e.preventDefault()
    if (!batch3) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Please Fill the Batch")
      return
    }

    try {
      setIsLoading4(true)
      const response = await getMentorListDataUseCase.invoke(auth, batch3)

      const csvContent = `data:text/csv;charset=utf-8,${response}`

      const encodedUri = encodeURI(csvContent)
      const link = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("download", `${batch3}.csv`)
      document.body.appendChild(link) // Required for FF
      link.click()
    } catch (error) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Error downloading file")
    }
    setIsLoading4(false)
  }

  const handleFormSubmitICPStudentList = async (e: any) => {
    e.preventDefault() // Prevent default form submission behavior

    if (!batch4) {
      alert("Please select a batch before downloading the student list.")
      return
    }

    try {
      setIsLoading5(true)
      let studentsResponse

      if (batch4 === "ICPStudents_activeBatches") {
        studentsResponse = await getICPStudentsOfBatchUseCase.invoke(auth)
      } else if (batch4 === "ICPStudents_nonactiveBatches") {
        studentsResponse = await getICPStudentsOfNonactiveBatchUseCase.invoke(auth)
      } else if (batch4 === "ICPStudents_allBatches") {
        studentsResponse = await getICPStudentsOfAllBatchUseCase.invoke(auth)
      } else {
        alert("Invalid batch selection.")
        return
      }

      const studentsData = Array.isArray(studentsResponse.data) ? studentsResponse.data : []

      if (studentsData.length === 0) {
        alert("No student data found!")
        return
      }

      // Prepare CSV rows
      const csvRows = ["Name,Email,Batch,Phone"]
      studentsData.forEach((student: any) => {
        const row = `${student.Name || ""},${student.Email || ""},${student.Batch || ""},${student.Phone || ""}`
        csvRows.push(row)
      })

      // Generate and download CSV
      const csvContent = `data:text/csv;charset=utf-8,${csvRows.join("\n")}`
      const encodedUri = encodeURI(csvContent)
      const link = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("download", "students_data.csv")
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error) {
      console.error("Error details:", error)
      changeToastVisibility(true)
      changeToastDetails("Error", "Error fetching students data")
    } finally {
      setIsLoading5(false)
    }
  }

  const handleFormSubmitMentorInstructorInvoices = async (e: React.FormEvent<HTMLFormElement>, role: string) => {
    e.preventDefault()
    if (!selectedYear || !selectedMonth || !role) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Please fill all fields")
      return
    }

    try {
      setIsLoading6(true)
      let response

      if (role === "Mentor") {
        response = await getMentorInvoicesUseCase.invoke(auth, selectedYear, selectedMonth)
      } else if (role === "Instructor") {
        response = await getInstructorInvoicesUseCase.invoke(auth, selectedYear, selectedMonth)
      } else if (role === "All") {
        response = await getMentorInstructorInvoicesUseCase.invoke(auth, selectedYear, selectedMonth)
      }

      const csvContent = `data:text/csv;charset=utf-8,${response}`
      const encodedUri = encodeURI(csvContent)
      const link = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("download", `${role}_Details_${selectedYear}_${selectedMonth}.csv`)
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Error downloading file")
    }
    setIsLoading6(false)
  }

  const handleFormSubmitMonthYear = async (e: any) => {
    e.preventDefault()
    if (downloadData == false) return
    setDownloadData(!downloadData)
    if (!batch2 || !monthList || !year) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Please fill all the fields")
      return
    }

    try {
      setIsLoading2(true)
      const response = await getBatchYearDataUseCase.invoke(auth, batch2, monthList, year)

      const csvContent = `data:text/csv;charset=utf-8,${response}`

      const encodedUri = encodeURI(csvContent)
      const link = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("download", `${batch}.csv`)
      document.body.appendChild(link) // Required for FF
      link.click()
    } catch (error) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Error downloading file")
    }
    setIsLoading2(false)
  }

  const handleUpdateBatchData = async () => {
    setDataButtonLoading(true)
    const response = await updateBatchDataUseCase.invoke(auth, batch2)
    if (response.success) {
      setDataButtonLoading(false)
      changeToastDetails(STR_SUCCESS, "Updated Batch Data")
      changeToastVisibility(true)
    } else {
      setDataButtonLoading(false)
      changeToastDetails(STR_FAILURE, response.error)
      changeToastVisibility(true)
    }

    return response.data
  }

  const handleFormSubmitBatchWiseCertificates = async (e: any) => {
    e.preventDefault()

    if (!batch5 || !course) {
      changeToastVisibility(true)
      changeToastDetails("failure", "Please fill in both Batch and Course")
      return
    }

    try {
      setIsLoading7(true)
      const response = await getBatchCertificatesUseCase.invoke(auth, batch5, course)
      if (response?.message?.includes("Certificates generated successfully")) {
        changeToastVisibility(true)
        changeToastDetails("success", "Certificates generated successfully for the selected batch")
      } else {
        changeToastVisibility(true)
        changeToastDetails("failure", "Error generating certificates.")
      }
    } catch (error) {
      changeToastVisibility(true)
      changeToastDetails("failure", "Error generating certificates.")
    } finally {
      setIsLoading7(false)
    }
  }

  const handleAllotMentors = async (event: React.FormEvent<HTMLFormElement>, batch: any) => {
    setAllotMentorsLoading(true)
    event.preventDefault()

    const response = await allotMentorsUseCase.invoke(auth, batch)
    setAllotMentorsLoading(false)
    if (response?.success) {
      changeToastDetails(STR_SUCCESS, "Mentors alloted successfully")
      changeToastVisibility(true)
    } else {
      changeToastDetails(STR_FAILURE, "Error Alloting mentors")
      changeToastVisibility(true)
    }
    return response.data
  }

  const handleGetTempMentorAnalysis = async (e: any) => {
    e.preventDefault()

    if (!fromDate3 || !toDate3) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Please fill all the fields")
      return
    }

    const fromTimestamp = new Date(fromDate3).getTime()
    const toTimestamp = new Date(toDate3).getTime()

    if (fromTimestamp > toTimestamp) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "From date cannot be greater than to date")
      return
    }

    try {
      setIsLoading8(true)

      const response = await getTempMentorAnalysisUseCase.invoke(auth, { fromDate3, toDate3 })

      if (!response?.data || !Array.isArray(response.data) || response.data.length === 0) {
        changeToastVisibility(true)
        changeToastDetails(STR_FAILURE, "No data available to download")
        return
      }

      // Define the required headers
      const headers = [
        "student_id",
        "original_mentor_id",
        "temp_mentor_mentor_id",
        "session_date",
        "batch",
        "session_status",
      ]

      // Create rows by extracting required fields from each object
      const rows = response.data.map((obj: any) => [
        obj.student_id,
        obj.mentor_id,
        obj.temp_mentor?.email || "", // Safely access nested mentor_id
        obj.session_date,
        obj.batch,
        obj.session_status,
      ])

      // Create CSV content: first row is headers, subsequent rows are object values
      const csvContent = `data:text/csv;charset=utf-8,${[
        headers.join(","), // Join headers with commas for the header row
        ...rows.map((row: any) => row.join(",")), // Join each row's values with commas
      ].join("\n")}` // Join all rows with newlines

      const encodedUri = encodeURI(csvContent)
      const link = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("download", "TEMP_MENTORSHIP_ANALYSIS.csv")
      document.body.appendChild(link)

      link.click()
    } catch (error) {
      changeToastVisibility(true)
      changeToastDetails(STR_FAILURE, "Error downloading file")
    }

    setIsLoading8(false)
  }

  const handleBatchChange = (e: any) => {
    setBatch(e.target.value)
  }

  const handleActivityStatusChange = (e: any) => {
    setActivityStatus(e.target.value)
  }

  const handleBatchChange2 = (e: any) => {
    setBatch2(e.target.value)
  }
  const handleBatchChange3 = (e: any) => {
    setBatch3(e.target.value)
  }

  const handleBatchChange4 = (e: any) => {
    setBatch4(e.target.value)
  }

  const handleSelectedBatchChange = (e: any) => {
    setSelectedBatch(e.target.value)
  }

  const handleFromDateChange = (e: any) => {
    setFromDate(e.target.value)
  }

  const handleToDateChange = (e: any) => {
    setToDate(e.target.value)
  }

  const handleFromDateChange2 = (e: any) => {
    setFromDate2(e.target.value)
  }

  const handleFromDateChange3 = (e: any) => {
    setFromDate3(e.target.value)
  }

  const handleToDateChange2 = (e: any) => {
    setToDate2(e.target.value)
  }

  const handleToDateChange3 = (e: any) => {
    setToDate3(e.target.value)
  }

  const handleMonthChange = (e: any) => {
    setMonth(e.target.value)
  }

  const handleAddMonth = () => {
    if (month === "") return
    if (monthList.includes(month)) return

    setMonthList([...monthList, month])
    setMonth("")
  }

  const formatMonth = (month: string): string => {
    const monthNumber = parseInt(month)
    return monthNumber < 10 ? `0${monthNumber}` : `${monthNumber}`
  }

  const handleRemoveMonth = (index: number) => {
    let newMonthList = monthList
    newMonthList = newMonthList.filter((m: string, i: number) => i !== index)
    setMonthList(newMonthList)
  }

  const handleYearChange = (e: any) => {
    setYear(e.target.value)
  }

  function submitForm() {
    setDownloadData(!downloadData)
  }

  async function setBatchData() {
    // setDataSetButton(!dataSetButton);
    setBlurSelect(true)
    await handleUpdateBatchData()
    setBlurSelect(false)
  }

  return {
    toast,
    allBatches,
    batch,
    fromDate,
    toDate,
    activityStatus,
    fromDate2,
    toDate2,
    isLoading,
    isLoading2,
    year,
    month,
    selectedMonth,
    selectedYear,
    selectedRole,
    monthList,
    batch2,
    allBatches2,
    isLoading3,
    isLoading4,
    isLoading5,
    isLoading6,
    isLoading7,
    dataSetButton,
    handleGetTempMentorAnalysis,
    blurSelect,
    dataButtonLoading,
    batch3,
    batch4,
    batch5,
    setBatch5,
    course,
    setCourse,
    allCourses,
    handleBatchChange3,
    handleBatchChange4,
    handleActivityStatusChange,
    submitForm,
    handleUpdateBatchData,
    handleFormSubmitMentorInstructorInvoices,
    handleFormSubmitBatchWiseCertificates,
    setSelectedMonth,
    setSelectedYear,
    setSelectedRole,
    formatMonth,
    setBatchData,
    handleFormSubmitDoubtSupport,
    handleFromDateChange2,
    handleToDateChange2,
    handleBatchChange2,
    handleFormSubmitMonthYear,
    handleRemoveMonth,
    handleAddMonth,
    handleMonthChange,
    fromDate3,
    toDate3,
    handleYearChange,
    handleFromDateChange,
    handleToDateChange,
    handleFormSubmit,
    handleBatchChange,
    handleFormSubmitMentorList,
    handleFormSubmitICPStudentList,
    fetchAllBatches2,
    fetchAllBatches,
    changeToastDetails,
    changeToastVisibility,
    handleAllotMentors,
    handleSelectedBatchChange,
    handleToDateChange3,
    handleFromDateChange3,
    selectedBatch,
    allotMentorsLoading,
    isLoading8,
  }
}
